module.exports = __webpack_public_path__ + "img/[在吗].ad4761d8.svg";